<template>
  <div class="settlement-order" @keyup.enter="enterSearch">
    <el-form class="table-search-bar" inline :model="searchForm" ref="searchForm">
      <el-form-item label="协议编号" prop="originalAgreemet">
        <el-input v-model="searchForm.originalAgreemet" placeholder="请输入协议编号" clearable></el-input>
      </el-form-item>
      <el-form-item label="订单编号" prop="originalOrder">
        <el-input v-model="searchForm.originalOrder" placeholder="请输入订单编号" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button @click="handleReset">重置</el-button>
        <el-button type="primary" v-permission="'0101502'" @click="handleSubmit">批量提交</el-button>
      </el-form-item>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="handData"
      style="width: 100%"
      tooltip-effect="light"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="originalAgreemet"
        label="原协议号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="originalOrder"
        label="原订单号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="originalTakeOrder"
        label="原提货单号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="itemName"
        label="商品名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="itemCode"
        label="商品编码"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orgName"
        label="经营组织"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="originalCunstomer"
        label="客户名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="销售数量"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.salesNum }}
        </template>
      </el-table-column>
      <el-table-column
        label="销售单价"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.salesUnitPrice }}
        </template>
      </el-table-column>
      <el-table-column
        label="销售总额"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.salesAmount }}
        </template>
      </el-table-column>
      <el-table-column
        label="客户单价"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.cunstomerPrice }}
        </template>
      </el-table-column>
      <el-table-column
        label="客户销售总额"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.cunstomerTotalAmount }}
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="新增时间"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="pointOut"
        label="失败原因"
        width="200"
        :show-overflow-tooltip="true">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
    <el-row class="export-row" type="flex" justify="end">
      <el-col :span="4">
        每页
        <el-select class="width100" v-model="exportForm.size" @change="handleExportSizeChange">
          <el-option v-for="item in sizeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        条
      </el-col>
      <el-col :span="4">
        第
        <el-select class="width100" v-model="exportForm.page">
          <el-option v-for="item in pageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        页
      </el-col>
       <el-col :span="3">
        <el-button v-permission="'0101501'" type="primary" @click="handleExport">导出为CSV文件</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'SettlementOrderHaiYunFailed',
  data () {
    return {
      loading: false,
      multipleSelection: [],
      searchForm: {
        dateRange: [],
        originalAgreemet: '',
        originalOrder: '',
        status: 1,
        handWorkOrderType: 1
      },
      exportForm: {
        size: 1000,
        page: 1
      },
      sizeOptions: [
        {
          label: '200',
          value: 200
        },
        {
          label: '500',
          value: 500
        },
        {
          label: '1000',
          value: 1000
        }
      ]
    }
  },
  computed: {
    ...mapState({
      handData: state => state.handOrder.hyhnBatchlist,
      listState: state => state.handOrder.hyhnBatchlistState
    }),
    pageOptions () {
      const total = this.listState.total
      const size = this.exportForm.size
      let totalPage = Math.floor(total / size)
      if (total % size) {
        totalPage++
      }
      const arr = []
      for (let index = 1; index <= totalPage; index++) {
        arr.push({
          label: index,
          value: index
        })
      }
      return arr
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    ...mapActions([
      'getHyHnBatchHandOrderList',
      'hyhnManualOrdersubmit',
      'exportHyhnFailedEnergyOrder'
    ]),
    // 获取表格数据
    async getTableData () {
      this.loading = true
      try {
        const params = { ...this.searchForm, pageNo: 1 }
        //   // 处理日期范围
        //   if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        //     params.startTime = this.searchForm.dateRange[0]
        //     params.endTime = this.searchForm.dateRange[1]
        //   }
        //   delete params.dateRange
        //   // 分页参数
        //   params.pageNum = this.pagination.currentPage
        //   params.pageSize = this.pagination.pageSize
        //   const params = {
        //   ...this.handForm,
        //   pageNo: 1
        // }
        this.getHyHnBatchHandOrderList(params)
        // 模拟数据
        // this.tableData = [
        //   {
        //     originalAgreemet: 'HY2024001-001',
        //     originalOrder: 'DJ2024001',
        //     originalDeliveryNo: 'THD2024001',
        //     productName: '聚丙烯',
        //     productCode: 'PP001',
        //     businessOrg: '海南分公司',
        //     customerName: '海南石化材料有限公司',
        //     saleQuantity: 1000,
        //     saleUnitPrice: 8500.00,
        //     saleTotalAmount: 8500000.00,
        //     customerUnitPrice: 8600.00,
        //     customerTotalAmount: 8600000.00,
        //     createTime: '2024-01-15 10:30:00',
        //     failureReason: 'SAP系统连接超时',
        //     unit: 't'
        //   }
        // ]
        // this.pagination.total = 1
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },

    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSearch () {
      const params = {
        ...this.searchForm,
        pageNo: 1
      }
      this.getHyHnBatchHandOrderList(params)
    },

    // 重置
    handleReset () {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        dateRange: [],
        originalAgreemet: '',
        originalOrder: '',
        status: 1,
        handWorkOrderType: 1
      }
      this.exportForm.page = 1
      this.getHyHnBatchHandOrderList(this.searchForm)
    },
    handleExport () {
      if (!Array.isArray(this.handData) || this.handData.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }

      const params = {
        originalAgreemet: this.searchForm.originalAgreemet,
        originalOrder: this.searchForm.originalOrder,
        status: 1,
        handWorkOrderType: 1,
        pageNo: 1,
        pageSize: this.exportForm.size
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.exportHyhnFailedEnergyOrder(params).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '海韵海南公司间结算失败订单.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      }).catch(() => {})
    },
    // 导出每页条数变动监听
    handleExportSizeChange (val) {
      this.exportForm.page = 1
    },
    handleSizeChange (val) {
      this.getHyHnBatchHandOrderList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getHyHnBatchHandOrderList({ pageNo: val })
    },
    // 勾选监听
    handleSelectionChange (val) {
      this.multipleSelection = val.map(item => item.id) || []
    },
    handleSubmit () {
      if (this.multipleSelection.length === 0) {
        return this.$message.warning('请先选择要提交的数据')
      }
      this.$confirm('是否批量提交？', '提醒', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.hyhnManualOrdersubmit({ ids: this.multipleSelection }).then(res => {
          this.$message.success('操作成功')
          this.handleSearch({ pageNo: 1 })
        })
      }).catch(() => {})
    }
  }

}
</script>

<style lang="scss" scoped>
.export-row {
  margin-top: 10px;
}
.width100{
  width: 100px;
}
</style>
